<template>
    <div>
        <table class="table table-bordered table-striped mt-4">
            <thead>
            <tr>
                <th>ID</th>
                <th>Created At</th>
                <th>Amount</th>
                <th>Purpose</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="income in incomes" :key="income.id">
                <td>{{ income.id }}</td>
                <td>{{ formatedDate(income.created_at) }}</td>
                <td>{{ income.amount + ' ' + currency }}</td>
                <td>{{ income.purpose}}</td>
            </tr>
            </tbody>
        </table>
        <b-pagination
            v-if="paginator.total / paginator.perPage > 1"
            :value="page"
            :total-rows="paginator.total"
            :per-page="paginator.perPage"
            @change="change($event)"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    name: "Incomes",
    props: {
        'page': {
            'default': 1
        },
        'clientId': {},
        'currency': {}
    },
    data() {
        return {
            incomes: [],
            paginator: []
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.getIncomes(event);
        },
        getIncomes(page) {
            window.axios.get('/admin/wallet/client/' + this.clientId + '/incomes', {params: {page: page}})
                .then(response => {
                        this.incomes = response.data.incomes;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
    },
    mounted() {
        this.getIncomes(this.page);
    }
}
</script>